module.exports = __webpack_public_path__ + "media/images/screenshot_browse_new-d20eea5801e947bb57b25c18c697f0ce.png";